export default __webpack_public_path__ + "bbdbc57aa7ffa104f62993c11421ecac.png";